import { Navigate, useLocation } from 'react-router-dom'
import App from '../App'
import { AppBootLoading } from '../components/AppBootLoading'
import { useAbp } from '../platform/abp/react'
import { peekPostLoginStudioPath } from '../scenarios/serverMode'
import { LOGIN_PATH, isAppShellPath, isUnsupportedLegacyUserPath } from './pathPolicy'
import { NotFoundPage } from './NotFoundPage'

type LoginLocationState = {
  returnTo?: string
}

/** Gates the operator shell: known app paths only; unknown URLs 404; auth required. */
export function AppShellRoute() {
  const location = useLocation()
  const { ready, isAuthenticated } = useAbp()

  // Unknown URLs 404 immediately — do not wait on session probe.
  if (isUnsupportedLegacyUserPath(location.pathname)) {
    return <NotFoundPage />
  }

  if (!isAppShellPath(location.pathname)) {
    return <NotFoundPage />
  }

  if (!ready) {
    return <AppBootLoading label="Loading…" />
  }

  if (!isAuthenticated) {
    const returnTo = `${location.pathname}${location.search}`
    return (
      <Navigate
        to={LOGIN_PATH}
        replace
        state={{ returnTo } satisfies LoginLocationState}
      />
    )
  }

  // OIDC finishes on `/`. A registration link for an existing account leaves the session here.
  if (location.pathname === '/') {
    const pendingStudioPath = peekPostLoginStudioPath()
    if (pendingStudioPath) {
      return <Navigate to={pendingStudioPath} replace />
    }
  }

  return <App />
}
